<template>
  <v-alert 
    border="top"
    v-model="tutoInfo"
    colored-border
    v-if="hasHelp"
    max-width="640"
    prominent
    type="info"
    class="mx-auto"
    elevation="2">
    
    <slot></slot>
    <v-row>
      <v-col cols="12" md="6">
        <v-btn color="info" @click="tutoInfo = false;" block>Got it!</v-btn>
      </v-col>
      <v-col cols="12" md="6">
        <v-btn color="warning" @click="disableHelp" block>Disable Help</v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>
<script>
export default {
  name: 'TutoInfo',
  data() {
    return {
      tutoInfo: true
    }
  },
  mounted() {
    this.$store.dispatch('tune/getUserProfile');
  },
  methods: {
    disableHelp() {
      this.$store.dispatch('tune/updateUserProfile', {
        id: this.userProfile.id,
        data: { user_settings: { help_text: false } }
      });
    }
  },
  computed: {
    hasHelp() {
      if (!this.userProfile.user_settings)
        return true
      return this.userProfile.user_settings.help_text;
    },
    userProfile() {
      return this.$store.state.tune.userProfile;
    },
  },

}
</script>
<style lang="scss">
</style>